var _defs, _rect, _rect2, _text, _text2, _text3, _rect3, _rect4, _rect5, _text4, _circle, _path, _path2, _rect6, _rect7, _path3, _text5, _rect8, _rect9, _rect10, _text6, _circle2, _path4, _path5, _rect11, _rect12, _path6, _text7, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _text8, _text9, _text10, _text11, _rect13, _rect14, _text12, _path25, _path26, _path27, _path28, _path29, _text13, _path30, _text14, _path31, _text15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArch = function SvgArch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "arch_svg__f4d6a11b-0457-4c4b-ae44-a4a2df9b26c6",
    "data-name": "Layer 1",
    viewBox: "0 0 680.3 475.36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arch_svg__f09797e6-9539-4c32-b49a-022e2c09fc30{fill:#466bb0}.arch_svg__e8fd0efc-502d-4997-81f5-96257f07fc0e,.arch_svg__f09797e6-9539-4c32-b49a-022e2c09fc30{opacity:.1}.arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c,.arch_svg__a49b4615-bc1c-41bd-b1e8-640b1f8dd42a,.arch_svg__b38d1ea6-a478-4fcb-bf29-b221edb8a33f,.arch_svg__e2e125c1-b406-488d-9663-154c8df4e9f4,.arch_svg__f0aad515-7ad9-45df-ab83-1f35aa91aec9,.arch_svg__f68635cb-cfa3-4a60-934b-de1f3aaa66c3{fill:none}.arch_svg__e2e125c1-b406-488d-9663-154c8df4e9f4{stroke:#466bb0;stroke-dasharray:10.01 10.01}.arch_svg__a49b4615-bc1c-41bd-b1e8-640b1f8dd42a,.arch_svg__b38d1ea6-a478-4fcb-bf29-b221edb8a33f,.arch_svg__e2e125c1-b406-488d-9663-154c8df4e9f4,.arch_svg__f68635cb-cfa3-4a60-934b-de1f3aaa66c3{stroke-linejoin:round}.arch_svg__a4076c78-2611-4424-b247-c2b071534796,.arch_svg__e19d6d5f-3b64-431f-ab4c-95c6ae498f56{font-size:12px}.arch_svg__a4076c78-2611-4424-b247-c2b071534796,.arch_svg__b1687d9f-cace-4cbf-9e86-85c41dc15326,.arch_svg__e19d6d5f-3b64-431f-ab4c-95c6ae498f56,.arch_svg__fa63d417-f2ec-400c-87e0-6baf8392cc5e{font-family:OpenSans,Open Sans}.arch_svg__e500ff81-4203-41af-b629-d871224c3705{fill:#e5e5e4}.arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e{fill:#fff}.arch_svg__b1687d9f-cace-4cbf-9e86-85c41dc15326,.arch_svg__fa63d417-f2ec-400c-87e0-6baf8392cc5e{font-size:14px}.arch_svg__abed5706-4125-4085-bdf7-e601c0ec9f14{fill:#767576}.arch_svg__b38d1ea6-a478-4fcb-bf29-b221edb8a33f,.arch_svg__f0aad515-7ad9-45df-ab83-1f35aa91aec9{stroke:#fff}.arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c,.arch_svg__a49b4615-bc1c-41bd-b1e8-640b1f8dd42a,.arch_svg__b38d1ea6-a478-4fcb-bf29-b221edb8a33f,.arch_svg__f0aad515-7ad9-45df-ab83-1f35aa91aec9{stroke-width:2px}.arch_svg__a49b4615-bc1c-41bd-b1e8-640b1f8dd42a,.arch_svg__f0aad515-7ad9-45df-ab83-1f35aa91aec9{stroke-linecap:round}.arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c,.arch_svg__ea00890b-4b69-4c4d-b458-bb1f52794665,.arch_svg__f0aad515-7ad9-45df-ab83-1f35aa91aec9{stroke-miterlimit:10}.arch_svg__f68635cb-cfa3-4a60-934b-de1f3aaa66c3{stroke:#b14d9d;stroke-width:3px}.arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c{stroke:#00a14b}.arch_svg__b056d124-143c-4300-a481-77e2ca9932d3{fill:#00a14b}.arch_svg__a49b4615-bc1c-41bd-b1e8-640b1f8dd42a{stroke:#486baf;stroke-dasharray:6 12}.arch_svg__ee4e281a-3b21-4c59-b369-dc727cb09c08{fill:#486baf}.arch_svg__e8fd0efc-502d-4997-81f5-96257f07fc0e{fill:#009345}.arch_svg__ea00890b-4b69-4c4d-b458-bb1f52794665{fill:#e4e4e3;stroke:#777678}.arch_svg__a4076c78-2611-4424-b247-c2b071534796,.arch_svg__b1687d9f-cace-4cbf-9e86-85c41dc15326{isolation:isolate}.arch_svg__b146f52f-4430-4517-8eda-8341602c0617{fill:#486bae}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 549.99,
    height: 96.23,
    x: 68.01,
    y: 360.11,
    className: "arch_svg__f09797e6-9539-4c32-b49a-022e2c09fc30",
    rx: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 580.5,
    height: 458.99,
    x: 49.9,
    y: 15.87,
    className: "arch_svg__e2e125c1-b406-488d-9663-154c8df4e9f4",
    rx: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__e19d6d5f-3b64-431f-ab4c-95c6ae498f56",
    transform: "translate(49.9 10.28)"
  }, "Istio Mesh")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__e19d6d5f-3b64-431f-ab4c-95c6ae498f56",
    transform: "translate(4.53 204.66)"
  }, "Ingress", /*#__PURE__*/React.createElement("tspan", {
    x: 3.84,
    y: 14.4
  }, "traffic"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__e19d6d5f-3b64-431f-ab4c-95c6ae498f56",
    transform: "translate(637.42 204.66)"
  }, "Egress", /*#__PURE__*/React.createElement("tspan", {
    x: 1.82,
    y: 14.4
  }, "traffic"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 136.06,
    height: 136.06,
    x: 120.77,
    y: 84.87,
    className: "arch_svg__e500ff81-4203-41af-b629-d871224c3705",
    rx: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 136.06,
    height: 136.06,
    x: 115.06,
    y: 79.15,
    className: "arch_svg__e500ff81-4203-41af-b629-d871224c3705",
    rx: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 40.35,
    x: 124.59,
    y: 86.73,
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e",
    rx: 3
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__fa63d417-f2ec-400c-87e0-6baf8392cc5e",
    transform: "translate(176.13 111.42)"
  }, "Service A")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 151.04,
    cy: 106.9,
    r: 18,
    className: "arch_svg__abed5706-4125-4085-bdf7-e601c0ec9f14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.65 100.39h12.79v12.79h-12.79z",
    className: "arch_svg__b38d1ea6-a478-4fcb-bf29-b221edb8a33f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.02 100.39v-3.08M151.04 100.39v-3.08M155.07 100.39v-3.08M147.02 116.5v-3.08M151.04 116.5v-3.08M155.07 116.5v-3.08M144.53 110.93h-3.08M144.53 106.9h-3.08M144.53 102.88h-3.08M160.64 110.93h-3.08M160.64 106.9h-3.08M160.64 102.88h-3.08",
    className: "arch_svg__f0aad515-7ad9-45df-ab83-1f35aa91aec9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68,
    height: 5.68,
    x: 148.2,
    y: 103.94,
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 39.08,
    x: 124.59,
    y: 164.69,
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e",
    rx: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.85 191.88v-15.3l-13.26-7.65-13.26 7.65v15.3l13.26 7.65z",
    className: "arch_svg__f68635cb-cfa3-4a60-934b-de1f3aaa66c3"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__fa63d417-f2ec-400c-87e0-6baf8392cc5e",
    transform: "translate(187.05 188.68)"
  }, "Proxy")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 136.06,
    height: 136.06,
    x: 434.89,
    y: 84.87,
    className: "arch_svg__e500ff81-4203-41af-b629-d871224c3705",
    rx: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 136.06,
    height: 136.06,
    x: 429.18,
    y: 79.15,
    className: "arch_svg__e500ff81-4203-41af-b629-d871224c3705",
    rx: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 40.35,
    x: 438.71,
    y: 86.73,
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e",
    rx: 3
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__fa63d417-f2ec-400c-87e0-6baf8392cc5e",
    transform: "translate(490.15 111.42)"
  }, "Service B")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 465.16,
    cy: 106.9,
    r: 18,
    className: "arch_svg__abed5706-4125-4085-bdf7-e601c0ec9f14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M458.77 100.39h12.79v12.79h-12.79z",
    className: "arch_svg__b38d1ea6-a478-4fcb-bf29-b221edb8a33f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M461.14 100.39v-3.08M465.16 100.39v-3.08M469.19 100.39v-3.08M461.14 116.5v-3.08M465.16 116.5v-3.08M469.19 116.5v-3.08M458.65 110.93h-3.08M458.65 106.9h-3.08M458.65 102.88h-3.08M474.76 110.93h-3.08M474.76 106.9h-3.08M474.76 102.88h-3.08",
    className: "arch_svg__f0aad515-7ad9-45df-ab83-1f35aa91aec9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68,
    height: 5.68,
    x: 462.32,
    y: 103.94,
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e",
    rx: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 39.08,
    x: 438.71,
    y: 164.69,
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e",
    rx: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M478.97 191.88v-15.3l-13.26-7.65-13.26 7.65v15.3l13.26 7.65z",
    className: "arch_svg__f68635cb-cfa3-4a60-934b-de1f3aaa66c3"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__fa63d417-f2ec-400c-87e0-6baf8392cc5e",
    transform: "translate(501.17 188.68)"
  }, "Proxy")), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 134.36v30.33",
    className: "arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m146.41 135.81 4.99-8.63 4.98 8.63z",
    className: "arch_svg__b056d124-143c-4300-a481-77e2ca9932d3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224.68 127.18v30.34",
    className: "arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m219.69 156.06 4.99 8.63 4.98-8.63z",
    className: "arch_svg__b056d124-143c-4300-a481-77e2ca9932d3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M241.59 184.23h189.94",
    className: "arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m430.07 189.22 8.64-4.99-8.64-4.98z",
    className: "arch_svg__b056d124-143c-4300-a481-77e2ca9932d3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 184.23h117.41",
    className: "arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m115.95 189.22 8.64-4.99-8.64-4.98z",
    className: "arch_svg__b056d124-143c-4300-a481-77e2ca9932d3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M555.71 184.23h117.41",
    className: "arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m671.66 189.22 8.64-4.99-8.64-4.98z",
    className: "arch_svg__b056d124-143c-4300-a481-77e2ca9932d3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M465.52 164.69v-30.33",
    className: "arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m470.5 135.81-4.98-8.63-4.99 8.63z",
    className: "arch_svg__b056d124-143c-4300-a481-77e2ca9932d3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M528.97 157.52v-30.34",
    className: "arch_svg__a0d2ecab-bc9b-44a8-82e3-34149afae16c"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m533.95 156.06-4.98 8.63-4.99-8.63z",
    className: "arch_svg__b056d124-143c-4300-a481-77e2ca9932d3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M340.2 378.3v-45.31H183.09V210.95",
    className: "arch_svg__a49b4615-bc1c-41bd-b1e8-640b1f8dd42a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m188.08 212.41-4.99-8.64-4.99 8.64z",
    className: "arch_svg__ee4e281a-3b21-4c59-b369-dc727cb09c08"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M340.2 332.99h157.01V210.95",
    className: "arch_svg__a49b4615-bc1c-41bd-b1e8-640b1f8dd42a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m502.2 212.41-4.99-8.64-4.99 8.64z",
    className: "arch_svg__ee4e281a-3b21-4c59-b369-dc727cb09c08"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__e19d6d5f-3b64-431f-ab4c-95c6ae498f56",
    transform: "translate(313.07 297.38)"
  }, "Discovery", /*#__PURE__*/React.createElement("tspan", {
    x: -11.26,
    y: 14.4
  }, "Configuration"), /*#__PURE__*/React.createElement("tspan", {
    x: -4.25,
    y: 28.8
  }, "Certificates"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__e19d6d5f-3b64-431f-ab4c-95c6ae498f56",
    transform: "translate(306.92 176.94)"
  }, "Mesh traffic")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__e19d6d5f-3b64-431f-ab4c-95c6ae498f56",
    transform: "translate(65.64 355.04)"
  }, "Control plane")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__e19d6d5f-3b64-431f-ab4c-95c6ae498f56",
    transform: "translate(69.28 116.18)"
  }, "Data", /*#__PURE__*/React.createElement("tspan", {
    x: -2.41,
    y: 14.4
  }, "plane"))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 549.99,
    height: 95.67,
    x: 68.01,
    y: 136.4,
    className: "arch_svg__e8fd0efc-502d-4997-81f5-96257f07fc0e",
    rx: 9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 378.75,
    height: 59.86,
    x: 150.77,
    y: 378.3,
    className: "arch_svg__ea00890b-4b69-4c4d-b458-bb1f52794665",
    rx: 3
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__b1687d9f-cace-4cbf-9e86-85c41dc15326",
    transform: "translate(197.69 412.46)"
  }, "istiod")), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "arch_svg__b243f9f5-a4f0-4ace-8728-20a55919deb2",
    d: "M165.65 394.45h27.55V422h-27.55z",
    className: "arch_svg__b146f52f-4430-4517-8eda-8341602c0617",
    "data-name": "background"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "arch_svg__bab6f098-e264-4a6f-a98c-5015ef270b55",
    d: "M172.47 415.7h13.91l-8.66 2.63z",
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e",
    "data-name": "hull"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "arch_svg__b00a4eed-a014-4f11-acfe-2bb9a5571d26",
    d: "m172.47 414.92 5.25-.79v-9.45z",
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e",
    "data-name": "mainsail"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "arch_svg__ecdc0ee3-43a6-4e31-a101-a29aed72bde8",
    d: "m178.51 414.13 7.87.79-7.87-17.06z",
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e",
    "data-name": "headsail"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M514.24 422.43h-74.6a3 3 0 0 1-3-3V397a3.08 3.08 0 0 1 3-3h74.6a3.08 3.08 0 0 1 3 3v22.4a3 3 0 0 1-3 3.03",
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__a4076c78-2611-4424-b247-c2b071534796",
    transform: "translate(459.81 410.94)"
  }, "Galley")), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M326.91 422.43h-74.6a3 3 0 0 1-3-3V397a3.08 3.08 0 0 1 3-3h74.6a3.08 3.08 0 0 1 3 3v22.4a3 3 0 0 1-3 3.03",
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__a4076c78-2611-4424-b247-c2b071534796",
    transform: "translate(277.22 410.94)"
  }, "Pilot")), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M420.58 422.43H346a3 3 0 0 1-3-3V397a3.08 3.08 0 0 1 3-3h74.6a3.08 3.08 0 0 1 3 3v22.4a3 3 0 0 1-3.02 3.03",
    className: "arch_svg__e3a70dc2-4442-4ba5-bd5d-d0d7fd4bf78e"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "arch_svg__a4076c78-2611-4424-b247-c2b071534796",
    transform: "translate(363.96 410.94)"
  }, "Citadel")));
};
export { SvgArch as ReactComponent };
export default __webpack_public_path__ + "static/arch.04060307.svg";